import { Children, memo } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const PaddedArea = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PaddedArea"
})(["padding:8px 16px;"]);
export const PrimaryMessageContentSectionWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageContentSection__PrimaryMessageContentSectionWrapper"
})(["overflow:hidden;width:100%;button{width:auto;}"]);
const PrimaryMessageContentSection = /*#__PURE__*/memo(({
  children,
  className
}) => {
  const hasContent = Children.count(children) > 0;
  if (!hasContent) {
    return null;
  }
  return /*#__PURE__*/_jsx(PrimaryMessageContentSectionWrapper, {
    "data-test-id": "primary-message-content-section",
    className: className,
    children: /*#__PURE__*/_jsx("div", {
      className: "width-100 padding-x-4 padding-y-2",
      children: /*#__PURE__*/_jsx(PaddedArea, {
        children: children
      })
    })
  });
});
PrimaryMessageContentSection.displayName = 'PrimaryMessageContentSection';
export default PrimaryMessageContentSection;